import { render, staticRenderFns } from "./templateManagement.vue?vue&type=template&id=68dc7869&scoped=true"
import script from "./templateManagement.vue?vue&type=script&lang=js"
export * from "./templateManagement.vue?vue&type=script&lang=js"
import style0 from "./templateManagement.vue?vue&type=style&index=0&id=68dc7869&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dc7869",
  null
  
)

export default component.exports